import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RsNgCarouselComponent } from './rs-ng-carousel.component';
import { RsNgBaseModule } from 'rs-ng-base';
import { RsNgCommonModule } from 'rs-ng-common';

@NgModule({
  declarations: [RsNgCarouselComponent],
  imports: [
    CommonModule,
    RsNgBaseModule,
    RsNgCommonModule
  ],
  exports: [
    RsNgCarouselComponent
  ]
})
export class RsNgCarouselModule { }
